import React from "react";
import {Button, Row, Col} from "react-bootstrap";
import Component from "../../components/AscComponent";
import CommonTable from "../../containers/Elements/Table/CommonTable";
import PermissionDeleteModal from "./PermissionDeleteModal";
import PermissionInsertModal from "./PermissionInsertModal";
import PermissionUpdateModal from "./PermissionUpdateModal";
import PermissionReadModal from "./PermissionReadModal";
import * as GlobalConst from '../../components/AscConstants';

// 【#419】件数を数値へ揃える。数値として扱えない値は「不明」を表す null を返す。
// null は Number(null) === 0 となり0名と区別できないため個別に弾く。
const toUserCount = (value) => {
    if (value === null || value === undefined) return null;
    const count = Number(value);
    return Number.isFinite(count) ? count : null;
};

// 【#419】削除させてはいけない件数か。1名以上が紐づく場合と、件数が不明な場合（安全側）。
const isDeleteBlockedCount = (count) => count === null || count > 0;

export default class Permission extends Component {
    constructor(props) {
        super(props);

        this.state = {
            // table item
            columns: this.getColumnsData(),
            data: [],
            pages: null,
            loading: false,
            filtered: [],
            sorted: [{id: "id", desc: true}],

            // modal item
            show: false,
            modalType: null,
            companySelect: [],

            selectedData: [],
        };
    }
    

    /**
     * 一覧表作成
     */
    getColumnsData() {
        return [
            {
                Header: this.props.langText.Body.CompanyName,
                accessor: "hm12_company.name",
                width: this.props.boardWidth.Name,
                Cell: data => {
                    if (data.row.original.hm12_company) {
                        return data.row.original.hm12_company.name;
                    } else {
                        return "";
                    }
                },
            }, {
                Header: this.props.langText.Body.PermissionName,
                accessor: "name",
            }, {
                Header: this.props.langText.Body.Memo,
                accessor: "memo",
            }, {
                Header: this.props.langText.Body.UserCount,
                width: this.props.boardWidth.xxsmall,
                // 【#408】集計を相関サブクエリへ移し、user_count は最上位の別名になった。
                // 従来の accessor は hm15_users.user_count でレスポンスキー
                // （hm15_user.user_count）と一致しておらず、並び替えが 400 になっていた。
                accessor: "user_count",
                Cell: data => {
                    return data.row.original.user_count || 0;
                },
            }, {
                Header: this.props.langText.Body.UpdateUserName,
                accessor: "update_user_name",
                width: this.props.boardWidth.Name,
                Cell: data => {
                    let update_users_info = data.row.original.update_users;

                    if (update_users_info) {
                        return update_users_info.family_name + " " + update_users_info.first_name;
                    } else {
                        return null
                    }
                },
            }, {
                Header: this.props.langText.Body.Modified,
                accessor: "modified",
                width: this.props.boardWidth.Date,
                Cell: ({value}) => value ?
                    this.getMomentTime({format: this.props.langText.Body.DateFormat, date: value}) : "",
            }
        ]
    }


    /**
     * 各ボタンから新しいmodal表示する際に使用する関数
     */
    modalShow = (modalType) => event => {
        let { selectedData } = this.state;

        event.preventDefault();
        let rowInfo = '';
        //ひとつだけ選択して編集または削除ボタンを押した場合
        if (modalType === "update" || modalType === "read" || (modalType === "delete" && selectedData.length === 1)) {
            rowInfo = selectedData.slice().pop();
        } 
        
        /**
         * stateに追加
         */
        //編集・削除の場合一つ以上の項目選択必須
        if((modalType === "update" || modalType === "read" || modalType === "delete" )&& selectedData.length === 0){
            return this.showErrorObjectMessage('ModalSelectError');
        }
        //編集場合一つの項目だけ選択可能
        if((modalType === "update" || modalType === "read") && selectedData.length > 1){
            return this.showErrorObjectMessage('UpdateModalSelectError');
        }

        // 【#419】単数選択時の件数。user_count と registered_user_flag を同じ値から
        // 導いて意味がずれないようにする（null を 0 として保存しつつフラグだけ立つ、
        // という不整合を避ける）。
        const rowUserCount = toUserCount(rowInfo && rowInfo.user_count);

        let setData = {
            permission_id: rowInfo && rowInfo.id
            ? rowInfo.id
            : 0,
            permission_name: rowInfo && rowInfo.name
            ? rowInfo.name
            : "",
            permission_memo: rowInfo && rowInfo.memo
            ? rowInfo.memo
            : "",
            // 件数が不明な場合は 0 を入れる（削除自体はフラグ側で止まるため送信されない）
            user_count: rowUserCount === null ? 0 : rowUserCount,
            // 【#419】削除可否はこのフラグだけで判定する（validationHandle 参照）。
            // 「1名以上が紐づく」または「件数が不明」のときに立てる。
            // 件数が不明な行を0名として扱うと、サーバー側の判定
            // （user_count に 1 以上が含まれるか）もすり抜けてしまうため、
            // 複数選択時と同じく安全側へ倒す。
            registered_user_flag: !!rowInfo && isDeleteBlockedCount(rowUserCount),
            modalType: modalType,
            show: true
        }

        if(modalType === "delete" && selectedData.length > 1){
            setData.permission_id = selectedData.map(row=>row.id);
            setData.permission_name = selectedData.map(row=>row.name);
            let user_count_arr = [];
            selectedData.forEach(row => {
                const count = toUserCount(row.user_count);
                if (isDeleteBlockedCount(count)) {
                    // 件数が不明な行も安全側に倒し、削除させない
                    setData.registered_user_flag = true;
                }
                if (count !== null) {
                    // 【#419】0名の行も含める。除外すると全件0名のときに空配列になり、
                    // 何件を対象にしているのかが分からなくなる
                    // （サーバー側は 1 以上が含まれるかだけを見るため判定は変わらない）。
                    user_count_arr.push(count);
                }
            });
            setData.user_count = user_count_arr;
        }
        /**
         * stateに権限詳細を追加
         */
        GlobalConst.CONTROLLER_LIST.forEach(row => {
            if (rowInfo && rowInfo.data[row]) {
                setData[row] = rowInfo.data[row];
            } else {
                // 【#475】row は "Record" 等の文字列のため、CONTROLLER_LIST[row] は常に undefined だった。
                // getPermissionReset は引数をキーにしたオブジェクトを作って即座に取り出す実装のため
                // 結果は同じで動作に影響は無いが、意図どおり row を渡す。
                setData[row] = this.getPermissionReset(row);
            }
        })

        this.setState(setData);
    };

    /**
     * 各画面先でのボタン押下時の動作内容
     */
    onClickHandle = modalType => event => {
        let {
            permission_id,
            permission_name,
            permission_memo,
            user_count
        } = this.state;

        let permissionList = {};
        GlobalConst.CONTROLLER_LIST.forEach(row => {
            permissionList[row] = this.state[row];
        })

        switch (modalType) {
            case "insert":
                this.blockUI();
                this
                    .ascAxios("post", `${this.reactContainerPath}/insert`, {
                        permission_id,
                        permission_name,
                        permission_memo,
                        permissionList
                    })
                    .then(result => {
                        alert(this.props.langText.Message.DataInsertSuccess);
                        this.reactTableRefresh(true);
                    })
                    .catch(err => {
                        console.error(err)
                        this.showErrorObjectMessage(err,'DataInsertError');
                    });
                this.setState({show: false})
                break
            case "update":
                this.blockUI();
                this
                    .ascAxios("post", `${this.reactContainerPath}/update`, {
                        permission_id,
                        permission_name,
                        permission_memo,
                        permissionList
                    })
                    .then(result => {
                        alert(this.props.langText.Message.DataUpdateSuccess);
                        this.reactTableRefresh(true);
                    })
                    .catch(err => {
                        console.error(err)
                        this.showErrorObjectMessage(err,'DataUpdateError');
                    })
                this.setState({show: false})
                break
            case "delete":
                this.blockUI();
                this
                    .ascAxios("post", `${this.reactContainerPath}/delete`, {
                        permission_id,
                        user_count
                    })
                    .then(result => {
                        alert(this.props.langText.Message.DataDeleteSuccess);
                        this.reactTableRefresh(true);
                    })
                    .catch(err => {
                        console.error(err)
                        this.showErrorObjectMessage(err,'DataDeleteError');
                    })
                this.setState({show: false})
                break
            default:
                alert(this.showErrorObjectMessage('ModalTypeError'));
        }
    };

    /**
     * 各画面のボタン押下条件
     */
    validationHandle = param => {
        let validation_flag = false;

        switch (param) {
            case "insert":
            case "update":
                validation_flag = !!(this.state.permission_name);
                break
            case "delete":
                // 【#419】user_count === 0 の厳密比較では、複数選択で全件0名のときに
                // user_count が配列（0名も含む）になり常に false となるため、
                // ユーザーが紐づかない権限をまとめて削除できなかった。
                // 判定を registered_user_flag に寄せ、単数・複数を同じ基準で扱う。
                validation_flag = !!(this.state.permission_id && !this.state.registered_user_flag);
                break
            case "read":
            default:
                break
        }

        return validation_flag;
    };

    /**
     * permissionData 初期化
     */
    getPermissionReset(controller_id) {
        let obj = {};

        // 【#475】既定値は AscConstants の DEFAULT_PERMISSION を正とする（App.js と共通）
        obj[controller_id] = {...GlobalConst.DEFAULT_PERMISSION}

        return obj[controller_id];
    }

    /**
     * modalTypeにより分岐させる
     */
    getModalBranch = () => {
        switch (this.state.modalType) {
            case "delete":
                return (
                    <PermissionDeleteModal
                        state = {this.state}
                        propSetState = {this.propSetState}
                        langText = {this.props.langText}
                        boardWidth={this.props.boardWidth}
                        onClick = {this.onClickHandle}
                        validationHandle = {this.validationHandle}/>
                )
            case "insert":
                return (
                    <PermissionInsertModal
                        state = {this.state}
                        permission = {this.props.currentPermission}
                        propSetState = {this.propSetState}
                        langText = {this.props.langText}
                        charaLimit = {this.props.charaLimit}
                        boardWidth={this.props.boardWidth}
                        onClick = {this.onClickHandle}
                        onTextChange_Limit = {this.onTextChange_Limit}
                        onNestSetState = {this.onNestSetState}
                        onNestCheckBoxChange = {this.onNestCheckBoxChange}
                        validationHandle = {this.validationHandle}
                        userInfo={this.props.userInfo}/>
                )
            case "update":
                return (
                    <PermissionUpdateModal
                        state = {this.state}
                        permission = {this.props.currentPermission}
                        propSetState = {this.propSetState}
                        langText = {this.props.langText}
                        charaLimit = {this.props.charaLimit}
                        boardWidth={this.props.boardWidth}
                        onClick = {this.onClickHandle}
                        onTextChange_Limit = {this.onTextChange_Limit}
                        onNestSetState = {this.onNestSetState}
                        onNestCheckBoxChange = {this.onNestCheckBoxChange}
                        validationHandle = {this.validationHandle}
                        userInfo={this.props.userInfo}/>
                )
            case "read":
                return (
                    <PermissionReadModal
                        state = {this.state}
                        propSetState = {this.propSetState}
                        langText = {this.props.langText}
                        boardWidth={this.props.boardWidth}
                        onClick = {this.onClickHandle}
                        validationHandle = {this.validationHandle}
                        userInfo={this.props.userInfo}/>
                )
            default:
                break
        }
    }

    render() {
        return (
            <div className="Permission">
                {/*一覧画面*/}
                <Row>
                    <Col xs={12} md={12}>
                        <Button
                            id = "permission-insert"
                            className = "table-button"
                            variant = "default"
                            size = "sm"
                            onClick={this.modalShow("insert")}
                            hidden={!this.props.currentPermission.create}
                        >
                            {this.props.langText.Body.InsertTitle}
                        </Button>
                        <Button
                            id = "permission-update"
                            className = "table-button"
                            variant = "default"
                            size = "sm"
                            onClick={this.modalShow("update")}
                            hidden={!this.props.currentPermission.update}
                            disabled={!(this.state.selectedData.length === 1)}
                        >
                            {this.props.langText.Body.UpdateTitle}
                        </Button>
                        <Button
                            id = 'user-read'
                            className = 'table-button'
                            variant = 'default'
                            size = 'sm'
                            onClick={this.modalShow('read')}
                            hidden={!!this.props.currentPermission.update}
                            disabled={!(this.state.selectedData.length === 1)}
                        >
                            {this.props.langText.Body.ReadTitle}
                        </Button>
                        <Button
                            id = "permission-delete"
                            className = "table-button"
                            variant = "default"
                            size = "sm"
                            onClick={this.modalShow("delete")}
                            hidden={!this.props.currentPermission.delete}
                            disabled={this.state.selectedData.length === 0}
                        >
                            {this.props.langText.Body.DeleteTitle}
                        </Button>
                    </Col>
                    <Col xs={12} md={12}>
                        <CommonTable
                            showPageSize={true}
                            showCheckbox={true}
                            showPagination={true}
                            propsPageIndex = {this.state.pageIndex? this.state.pageIndex: 0}
                            state = {this.state}
                            tableHeight={this.props.tableHeight}
                            tbodyHeight={this.props.tableHeight-30}
                            columns={this.state.columns}
                            data={this.state.data}
                            loading={this.state.loading}
                            onFetchData={this.fetchData}
                            filtered={this.state.filtered}
                            sorted={this.state.sorted}
                            pageCount = {this.state.pageCount}
                            manual = {true}
                            langText = {this.props.langText.Table}
                            onSelectedDataChange={(selected) => {
                                this.setState({ selectedData: selected });
                            }}
                        />
                    </Col>
                </Row>
                {/*モーダル表示分岐*/}
                {this.getModalBranch()}
            </div>
        );
    }
}
